import React from 'react'
import ConsumerList from '../components/Consumers/ConsumerList'

function Consumers() {
  return (
    <ConsumerList/>
  )
}

export default Consumers